import { Row as AntRow, Col as AntCol } from 'antd';

export const Row = AntRow;

export const Col = AntCol;
